import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'AppActivity';

const AppActivityApi: any = baseApi(endpoint);

export default AppActivityApi;